<template>
    <div class="step1">
        <h1>Aanvraagformulier</h1>
        <h2>Aanvraag</h2>

        <application-stepper current-step="1" :loading="!loaded">
            <h3>Aanvraag</h3>

            <v-form @submit.prevent="submit">
                <v-error-messages ref="errorMessages" :messages="this.errorMessages"></v-error-messages>

                <v-text-field
                    v-model="application.shortDescription"
                    label="Wat wilt u aanvragen"
                    readonly
                ></v-text-field>

                <v-textarea :error="hasErrors('requestReason')" :error-messages="handleErrors('requestReason')" v-model="application.requestReason" label="De reden van aanvraag" required></v-textarea>

                <v-row>
                    <v-spacer></v-spacer>
                    <v-col cols="auto">
                        <v-btn color="primary" @click="submit" :loading="submitBtnClicked" :disabled="submitting"
                            >Volgende</v-btn
                        >
                    </v-col>
                </v-row>
            </v-form>
        </application-stepper>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import ApplicationStepper from '../components/ApplicationStepper';
import VErrorMessages from '@/components/VErrorMessages';

export default {
    name: 'step1-reason',
    components: {
        ApplicationStepper,
        VErrorMessages,
    },
    data: () => ({
        errorDetails: {},
        loaded: false,
        backBtnClicked: false,
        submitBtnClicked: false,
        submitting: false,

        errorMessages: [],
        application: {
            shortDescription: null,
            requestReason: null,
        },
    }),
    computed: {
        ...mapGetters({ vuex: 'step1' }),
    },
    created: function() {
        const that = this;

        this.step1Load().then(function() {
            that.application.shortDescription = that.vuex.application.shortDescription;
            that.application.requestReason = that.vuex.application.requestReason;

            that.loaded = true;
        });
    },
    methods: {
        ...mapActions(['step1Load', 'step1Submit']),
        hasErrors(name) {
            return '' !== this.handleErrors(name);
        },
        handleErrors(name) {
            if (this.errorDetails[name] !== undefined) {
                let error = '';
                Object.entries(this.errorDetails[name]).forEach(entry => {
                    const [errorType, value] = entry;
                    error += " " + value;
                });
                return error;
            }
            return '';
        },
        submit: function() {
            const that = this;
            this.submitBtnClicked = true;
            this.submitting = true;
            this.errorMessages = [];

            this.step1Submit(this.$data)
                .then(function() {
                    that.$router.push({ name: 'step2_contact' });
                })
                .catch(function (error) {
                    const response = error.response;
                    if (response.data !== undefined && response.data.error !== undefined) {
                        that.errorDetails = response.data.error.messages;
                        that.errorMessages = ['Er ontbreken gegevens in deze stap'];
                    } else {
                        that.errorMessages = ['Onbekende fout!'];
                    }
                    that.$vuetify.goTo(that.$refs.errorMessages, {
                        duration: 300,
                        offset: 100,
                        easing: 'easeInOutCubic',
                    });
                })
                .finally(function() {
                    that.submitBtnClicked = false;
                    that.submitting = false;
                });
        },
    },
};
</script>
